import { Injectable, Signal, signal } from '@angular/core'

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    private loading = signal<boolean>(false)
    private shouldBlockUI = true

    public get(): Signal<boolean> {
        return this.loading
    }

    public set(value: boolean): void {
        this.loading.set(value)
    }

    public getShouldBlockUI(): boolean {
        return this.shouldBlockUI
    }

    public setShouldBlockUI(value: boolean): void {
        this.shouldBlockUI = value
    }
}
